import axios from 'axios';

export default axios.create({
  baseURL: 'https://portal.dynamicsats.com',
  headers: {
    Accept: 'application/rss+xml',
  },
});
